import React, { useState, useMemo, useCallback } from "react";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
// import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
} from "@mui/material";
// import ActionItems from "../shared/ActionItems";
import TablePaginations from "../shared/TablePaginations";
import { TableWrapper, ActionButtonMain } from "../shared/styles/TableStyles";
import EditPermissions from "./EditPermissions";
import { EditButton } from "./styles/EditPermissionsStyle";

const UserTable = ({
  TableHeadData = [],
  BodyData = [],
  CurrentPage = 1,
  setCurrentPage = () => {},
  total_pages = "",
}) => {
  const [sortConfig, setSortConfig] = useState({
    key: "",
    direction: "asc",
  });

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key: key, direction: direction });
  };

  const sortedData = useMemo(() => {
    const sortedArray = [...BodyData];

    sortedArray.sort((a, b) => {
      const aValue = a[sortConfig.key];
      const bValue = b[sortConfig.key];

      if (typeof aValue === "string" && typeof bValue === "string") {
        return sortConfig.direction === "asc"
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      }

      return sortConfig.direction === "asc" ? aValue - bValue : bValue - aValue;
    });

    return sortedArray;
  }, [BodyData, sortConfig]);

  // ===== this is for the action buttons

  // const [anchorEl, setAnchorEl] = useState(null);
  // const handleClick = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };
  // const handleClose = () => {
  //   setAnchorEl(null);
  // };

  // const open = Boolean(anchorEl);
  // const id = open ? "simple-popover" : undefined;

  // this is for the   paginations

  const pagedData = sortedData;
  const handleChangePage = (page) => {
    setCurrentPage(page);
  };

  // show and hide the Edit Permissions popup
  const [openDialog, setOpenDialog] = useState(false);
  const [selectRowData, setSelectRowData] = useState(null);
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  const handleOpenDialog = useCallback((row) => {
    const { id, Permissions } = row;
    setSelectRowData({
      id,
      Permissions,
    });
    setOpenDialog(true);
  }, []);

  return (
    <TableWrapper className="TableWrapper">
      <TableContainer className="TableContainer">
        <Table>
          <TableHead>
            <TableRow className="table_head">
              {TableHeadData.map((value, index) => (
                <TableCell key={value.title + "_" + index}>
                  <TableSortLabel
                    active={sortConfig.key === value.val}
                    direction={sortConfig.direction}
                    onClick={() => handleSort(value.val)}
                    IconComponent={ArrowDropUpIcon}
                  >
                    {value.title}
                  </TableSortLabel>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody className="table_body">
            {pagedData?.map((row, index) => {
              return (
                <>
                  <TableRow key={index} className={`table__row ${row}`}>
                    {Object.entries(row).map(([key, value], cellIndex) => {
                      return (
                        <>
                          <TableCell
                            key={cellIndex + "_" + value}
                            className={`${key}`}
                          >
                            {/* {value} */}
                            {(() => {
                              // if (key === "Permissions") {
                              //   // return value || "N/A";
                              //   return null;
                              // }

                              return value || "N/A";
                            })()}
                          </TableCell>
                        </>
                      );
                    })}

                    <TableCell style={{ textAlign: "right" }}>
                      {/*  */}
                      <EditButton onClick={() => handleOpenDialog(row)}>
                        Edit Permissions
                      </EditButton>
                    </TableCell>
                  </TableRow>
                </>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      {total_pages > 1 && (
        <TablePaginations
          currentPage={CurrentPage}
          totalPages={total_pages}
          // sortedData={sortedData}
          handleChangePage={handleChangePage}
        />
      )}
      <EditPermissions
        handleCloseDialog={handleCloseDialog}
        openDialog={openDialog}
        selectRowData={selectRowData}
      />
    </TableWrapper>
  );
};

export default UserTable;
